import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} 
from "../../../../redux/slices/common/sliceFunctions";

var entitiesName = 'tags';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchTagsService(dataSlice) {
  dataSlice.dataUrl.code="GET_TAGS";
  return _fetchEntitiesService(dataSlice,events);
}